import RequestSummaryItemModelBase from '../_generated/modelBases/request-summary-item-model-base';

export default class RequestSummaryItemModel extends RequestSummaryItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
